import { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { storeToken } from "../services/auth";

export default function LoginPage() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    email: "admin@movigo.com",
    password: "password123",
  });
  const [error, setError] = useState("");

  const handleChange = (event) => {
    setFormValues((current) => ({
      ...current,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!formValues.email || !formValues.password) {
      setError("Email and password are required.");
      return;
    }

    storeToken("mock-admin-jwt");
    navigate("/");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "linear-gradient(135deg, #0e3b43 0%, #1f6b75 55%, #ffb46a 100%)",
        px: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 440, borderRadius: 4 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h4" fontWeight={800}>
            Movigo Admin
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 1, mb: 3 }}>
            Sign in to monitor drivers and rides.
          </Typography>

          <Stack component="form" spacing={2} onSubmit={handleSubmit}>
            {error ? <Alert severity="error">{error}</Alert> : null}
            <TextField label="Email" name="email" value={formValues.email} onChange={handleChange} fullWidth />
            <TextField
              label="Password"
              name="password"
              type="password"
              value={formValues.password}
              onChange={handleChange}
              fullWidth
            />
            <Button type="submit" variant="contained" size="large">
              Login
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
